const baseUrl = process.env.VUE_APP_API_URL;

export default {
  apiUrl: baseUrl,
  endpoints: {
    login: `${baseUrl}/login_check`,
    getUser: `${baseUrl}/api/secure/user/get-user`,
    getMeasures: (deviceId) => `${baseUrl}/api/secure/measures-proxy/get-measure/${deviceId}`,

    getUserDevices: () => `${baseUrl}/api/secure/device/user-devices`,
    getUserStructures: () => `${baseUrl}/api/secure/structures/user-structures`,

    requestResetPassword: () => `${baseUrl}/api/user/request-reset-password`,
    resetPassword: () => `${baseUrl}/api/user/reset-password`,

    getDashboardStructure: (structureId) => `${baseUrl}/api/secure/structure/${structureId}/dashboard`,
    structureDetails: (structureId) => `${baseUrl}/api/secure/structure/${structureId}/details`,
    updateStructure: (structureId) => `${baseUrl}/api/secure/structure/${structureId}/update`,
    postInviteToStructure: (structureId) => `${baseUrl}/api/secure/structure/${structureId}/invite-to-structure/`,

    exportMeasures: (deviceId) => `${baseUrl}/api/secure/export/measures-data/${deviceId}`,
    exportMeasuresDevices: () => `${baseUrl}/api/secure/export/measures-data-selected`,

    userGetInvitation: (token) => `${baseUrl}/api/user/invitation/${token}`,
    userAcceptInvitation: (token) => `${baseUrl}/api/user/accept-invitation/${token}`,

    disableStructureAccess: (structureAccessId) => `${baseUrl}/api/secure/structure-access/${structureAccessId}/disable`
  }
};
